module.exports = __webpack_public_path__ + "img/zju-logo.467ba4d8.png";